(function(){
  'use strict';
  var root=document.documentElement, body=document.body, KEY='ase-theme';
  var R=window.routes||{cart_add:'/cart/add.js',cart_change:'/cart/change.js',cart_url:'/cart'};
  function qs(s,c){return (c||document).querySelector(s);}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}

  /* [17] Theme preference is applied by an inline head script before first
     paint. This only drives the toggle and its pressed state. */
  var tb=qs('#themeToggle');
  function syncToggle(){ if(tb) tb.setAttribute('aria-pressed', root.dataset.theme==='light'?'true':'false'); }
  syncToggle();
  if(tb) tb.addEventListener('click',function(){
    root.dataset.theme = root.dataset.theme==='light' ? 'dark' : 'light';
    try{ localStorage.setItem(KEY, root.dataset.theme); }catch(e){}
    syncToggle();
  });

  /* [3] Reveal on scroll. CSS defaults to visible and opts in via the .js class
     on <html>, so a JS failure can no longer leave the page blank. */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    qsa('.reveal').forEach(function(el){io.observe(el);});
  } else { qsa('.reveal').forEach(function(el){el.classList.add('in');}); }

  var hdr=qs('header');
  window.addEventListener('scroll',function(){ if(hdr) hdr.classList.toggle('scrolled', window.pageYOffset>40); },{passive:true});

  /* [30] Overlay focus management: move focus in, trap Tab, restore focus to
     the trigger on close, keep aria-expanded accurate. */
  var backdrop=qs('[data-overlay]'), lastTrigger=null, activeOverlay=null;
  var FOCUSABLE='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function focusables(el){ return qsa(FOCUSABLE, el).filter(function(n){ return n.offsetParent!==null || n===document.activeElement; }); }

  function onTrapKey(e){
    if(e.key!=='Tab'||!activeOverlay) return;
    var f=focusables(activeOverlay); if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }

  function setExpanded(sel,val){ qsa(sel).forEach(function(b){ b.setAttribute('aria-expanded', val); }); }

  function openOv(el, trigger){
    if(!el) return;
    lastTrigger = trigger || document.activeElement;
    activeOverlay = el;
    el.classList.add('open');
    el.setAttribute('aria-hidden','false');
    body.classList.add('ov-open');
    if(backdrop) backdrop.classList.add('show');
    if(el.id==='MenuPanel') setExpanded('[data-menu-toggle]','true');
    if(el.id==='SearchOverlay') setExpanded('[data-search-toggle]','true');
    document.addEventListener('keydown', onTrapKey);
    setTimeout(function(){ var f=focusables(el); if(f.length) f[0].focus(); },60);
  }

  function closeAll(){
    var wasOpen = !!activeOverlay;
    qsa('.drawer.open,.menu-panel.open,.search-ov.open').forEach(function(e){
      e.classList.remove('open'); e.setAttribute('aria-hidden','true');
    });
    body.classList.remove('ov-open');
    if(backdrop) backdrop.classList.remove('show');
    setExpanded('[data-menu-toggle]','false');
    setExpanded('[data-search-toggle]','false');
    document.removeEventListener('keydown', onTrapKey);
    activeOverlay=null;
    if(wasOpen && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger=null;
  }

  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });
  function setCount(n){ qsa('#cartCount').forEach(function(e){e.textContent=n;}); }

  function refreshDrawer(open, trigger){
    return fetch('/?sections=cart-drawer',{headers:{'X-Requested-With':'fetch'}})
      .then(function(r){ return r.json(); })
      .then(function(j){
        var wrap=qs('#shopify-section-cart-drawer');
        if(wrap && j['cart-drawer']!=null) wrap.innerHTML=j['cart-drawer'];
        var nd=qs('#CartDrawer');
        if(nd){
          var c=nd.getAttribute('data-cart-count');
          if(c!=null) setCount(c);
          if(open){ activeOverlay=null; openOv(nd, trigger); }
        }
      })
      .catch(function(){});
  }

  function addToCart(id, qty, btn){
    if(!id) return;
    var fd=new FormData(); fd.append('id',id); fd.append('quantity',qty||1);
    if(btn){ btn.classList.add('loading'); btn.setAttribute('aria-busy','true'); }
    return fetch(R.cart_add,{method:'POST',headers:{'X-Requested-With':'fetch','Accept':'application/json'},body:fd})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
      .then(function(res){
        if(!res.ok){ toast((res.d&&(res.d.description||res.d.message))||'Could not add to cart', false); return; }
        return refreshDrawer(true, btn).then(function(){
          toast('Added to your cart');
          if(btn){ btn.classList.add('added'); var o=btn.dataset.label||btn.textContent; btn.dataset.label=o; btn.textContent='Added'; setTimeout(function(){btn.classList.remove('added'); btn.textContent=o;},1500); }
        });
      })
      .catch(function(){ toast('Something went wrong', false); })
      .finally(function(){ if(btn){ btn.classList.remove('loading'); btn.removeAttribute('aria-busy'); } });
  }

  function changeLine(line, qty){
    return fetch(R.cart_change,{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'fetch'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(){ return refreshDrawer(false); });
  }

  document.addEventListener('click',function(e){
    var t=e.target;
    var ct=t.closest('[data-cart-toggle]'); if(ct){ e.preventDefault(); return openOv(qs('#CartDrawer'), ct); }
    var mt=t.closest('[data-menu-toggle]'); if(mt){ e.preventDefault(); return openOv(qs('#MenuPanel'), mt); }
    var stg=t.closest('[data-search-toggle]'); if(stg){ e.preventDefault(); return openOv(qs('#SearchOverlay'), stg); }
    var ch=t.closest('[data-change]'); if(ch){ e.preventDefault(); return changeLine(parseInt(ch.getAttribute('data-line'),10), parseInt(ch.getAttribute('data-qty'),10)); }
    var qa=t.closest('[data-quick-add]'); if(qa){ e.preventDefault(); return addToCart(qa.getAttribute('data-quick-add'),1,qa); }

    /* [29] PDP thumbnails are buttons — keyboard operable. */
    var th=t.closest('[data-thumb]');
    if(th){
      e.preventDefault();
      var m=qs('[data-main-image]');
      if(m){ m.removeAttribute('srcset'); m.src=th.getAttribute('data-full'); }
      qsa('[data-thumb]').forEach(function(b){ b.removeAttribute('aria-current'); });
      th.setAttribute('aria-current','true');
      return;
    }

    if(t.closest('[data-overlay]')) return closeAll();
    var cl=t.closest('[data-close]');
    if(cl){
      var href=cl.getAttribute('href');
      if(cl.tagName==='A'&&href&&href!=='#'){ closeAll(); }
      else { e.preventDefault(); closeAll(); }
    }
  });

  document.addEventListener('submit',function(e){
    var f=e.target;

    if(f.classList.contains('pdp-form')){
      e.preventDefault();
      var idEl=f.querySelector('[name=id]'), qEl=f.querySelector('[name=quantity]');
      addToCart(idEl&&idEl.value, (qEl&&qEl.value)||1, f.querySelector('[name=add]'));
      return;
    }

    /* [8] The newsletter used to show "Thank you" on every response, including
       errors, so failed signups looked successful. It now verifies the response
       and falls back to a native form post when it cannot confirm. Note that
       HTMLFormElement.prototype.submit does not fire a submit event, so this
       cannot recurse. */
    if(f.classList.contains('js-newsletter')){
      e.preventDefault();
      var btn=f.querySelector('button[type=submit]');
      if(btn) btn.disabled=true;
      fetch(f.action,{method:'POST',body:new FormData(f),headers:{'X-Requested-With':'fetch'}})
        .then(function(r){ if(!r.ok) throw new Error('http '+r.status); return r.text(); })
        .then(function(html){
          if(/form_success|posted_successfully|thank you/i.test(html)){
            toast('Thank you — you are in.');
            f.reset();
          } else {
            HTMLFormElement.prototype.submit.call(f);
          }
        })
        .catch(function(){ HTMLFormElement.prototype.submit.call(f); })
        .finally(function(){ if(btn) btn.disabled=false; });
    }
  });

  /* [36] Variant change reads the formatted price from a data attribute instead
     of parsing the option label, and keeps ?variant= in the URL so a specific
     variant can be linked. */
  document.addEventListener('change',function(e){
    var sel=e.target;
    if(!sel.matches || !sel.matches('.pdp-form select[name=id]')) return;
    var opt=sel.options[sel.selectedIndex];
    if(!opt) return;

    var money=opt.getAttribute('data-price');
    if(!money){ var parts=opt.textContent.split('—'); money=parts.length>1?parts.pop().trim():''; }
    var pe=qs('[data-price]'); if(pe&&money) pe.textContent=money;

    var avail=opt.getAttribute('data-available')!=='false';
    var ab=qs('.pdp-form [name=add]');
    if(ab){ ab.disabled=!avail; ab.textContent=avail?'Add to Cart':'Sold Out'; }

    try{
      var u=new URL(window.location.href);
      u.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', u.toString());
    }catch(err){}
  });

  var tw=qs('#toast');
  function toast(msg, ok){
    if(!tw) return;
    var el=document.createElement('div');
    el.className='toast'+(ok===false?' err':'');
    el.textContent=msg;
    tw.appendChild(el);
    requestAnimationFrame(function(){el.classList.add('show');});
    setTimeout(function(){ el.classList.remove('show'); setTimeout(function(){el.remove();},420); },2600);
  }

  /* Predictive search — output is escaped before it reaches the DOM. */
  var sInput=qs('#SearchOverlay input[type=search]'), sResults=qs('#SearchResults'), timer;
  if(sInput && sResults){
    sInput.addEventListener('input',function(){
      clearTimeout(timer);
      var q=sInput.value.trim();
      if(q.length<2){ sResults.innerHTML=''; return; }
      timer=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6',{headers:{'X-Requested-With':'fetch'}})
          .then(function(r){return r.json();})
          .then(function(j){
            var ps=(j.resources&&j.resources.results&&j.resources.results.products)||[];
            if(!ps.length){ sResults.innerHTML='<p class="sempty">No matches found.</p>'; return; }
            sResults.innerHTML=ps.map(function(p){
              var img=(p.featured_image&&p.featured_image.url)?'<img src="'+esc(p.featured_image.url)+'" alt="" width="44" height="56" loading="lazy">':'';
              var pr=p.price?'<i>'+esc(p.price)+'</i>':'';
              return '<a class="sresult" href="'+esc(p.url)+'">'+img+'<span><b>'+esc(p.title)+'</b>'+pr+'</span></a>';
            }).join('');
          })
          .catch(function(){ sResults.innerHTML='<p class="sempty">Search unavailable.</p>'; });
      },200);
    });
  }
})();
